// extracted by mini-css-extract-plugin
export default {"root":"FeaturesList_root-nJY"};